export var DefaultEffects = {
    // commented values are the defaults for Fluent
    elevation4: { boxShadow: '0 0 5px 0 rgba(0,0,0,.4)' },
    elevation8: { boxShadow: '0 0 5px 0 rgba(0,0,0,.4)' },
    elevation16: { boxShadow: '0 0 5px 0 rgba(0,0,0,.4)' },
    elevation64: { boxShadow: '0 0 5px 0 rgba(0,0,0,.4)' },
    roundedCorner2: 0 // 2
};
//# sourceMappingURL=DefaultEffects.js.map